import { LazyModule } from 'owa-bundling';

const lazyPickerPluginModule = new LazyModule(() =>
    import(/* webpackChunkName: "PickerPluginModule" */ 'roosterjs-plugin-picker')
);

export { lazyPickerPluginModule };
